import pt from "./pt";
import en from "./en";
import es from "./es";
import fr from "./fr";

export const LOCALES = ["pt", "en", "es", "fr"];
export const LOCALE_LABELS = { pt: "PT", en: "EN", es: "ES", fr: "FR" };

const dicts = { pt, en, es, fr };

const resolve = (dict, path) =>
  path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);

export const translate = (lang, path) => {
  const val = resolve(dicts[lang] || pt, path);
  if (val !== undefined) return val;
  const fallback = resolve(pt, path);
  return fallback !== undefined ? fallback : path;
};
